import isEmpty from 'lodash/isEmpty';
import MenuItem from 'src/models/menu/menuItem';
import MenuItemGroup from 'src/models/menu/menuItemGroup';
import { contentAxiosInstance } from 'src/boot/axios';

export function fetchItems({ commit, state }) {
  if (!isEmpty(state.items)) return;
  commit('setIsLoading', true);

  contentAxiosInstance
    .get('/frontend-content/menu/menu.json')
    .then((response) => {
      if (!isEmpty(response.data.menu)) {
        commit(
          'setItems',
          response.data.menu.map((item) => {
            switch (item.type) {
              case 'menu-item':
                return new MenuItem(item);
              case 'menu-item-group':
                return new MenuItemGroup(item);
              default:
                throw new Error('Unkown menu item type');
            }
          }),
        );
      }
    })
    .finally(commit('setIsLoading', false));
}

export function updateActiveSubMenuName({ commit }, payload) {
  commit('setActiveSubMenuName', null);

  // Make sure rerendering / animation(s) occurs
  setTimeout(() => {
    commit('setActiveSubMenuName', payload);
  }, 100);
}
